module.exports = "/_next/static/images/2af80081db969ec5f038fea9b4547563-challenge-system-large.jpg.webp";